<template>

<div class="filters">

	<slot></slot>

	<div class="filters-reset" :class="{'is-disabled': !changed}" v-tooltip="'Click to reset all filters'" v-on:click="$emit('reset')"><i class="fa-solid fa-remove"></i></div>

</div>

</template>

<script>

export default {

	props: ['changed']

}

</script>

<style scoped>

.filters {
	width: 100%;
	background-color: #fff;
	height: 33px;
	display: flex;
	flex-direction: row;
	flex-shrink: 0;
	border-bottom: 1px solid #eee;
}

.filters > div {
	border-right: 1px solid #eee;
	min-width: 64px;
}

.filters > div:last-child {
	border-right: 0px;
}

.filters-reset {
	height: 24px;
    line-height: 24px;
    padding: 0px 5px;
    border-radius: 4px;
    margin: 4px 4px;
    font-size: 12px;
    font-weight: 500;
	min-width: 24px!important;
	text-align: center;
    cursor: pointer;
    background-color: #6b7488;
    color: #fff;
}

.filters-reset.is-disabled {
	pointer-events: none;
	opacity: 0.25;
}

.filters-reset:hover {
	background-color: #535b6c;
}

</style>
